import Autosuggest from "@storeblocks/autosuggest";
import styled from "styled-components";

interface MarginProps {
  marginBottom: "0px" | "32px";
}

export const StyledAutosuggest = styled(Autosuggest)<MarginProps>`
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;
